import { RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"
import { IssuePriority } from "src/util/types/dataModels/issuePriority"

//region Types

export type IssuePriorityDocument = RxDocument<IssuePriority>
export type IssuePriorityCollection = RxCollection<IssuePriority>

//endregion

/**
 * Schema for issue priority collections
 */
export const issuePrioritySchema: RxJsonSchema<IssuePriority> = {
  title: "Issue Priority schema",
  description: "Collection of all issue priorities",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    label: { type: "string", maxLength: 100 },
    risk_factor: { type: "number", maximum: 100, minimum: 1 },
    days_to_correct: { type: "number", maximum: 32767, minimum: 0 },
    work_domain: { type: "string", maxLength: 36 },
  },
  required: ["id", "label", "risk_factor", "work_domain"],
  indexes: ["label"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const issuePriorityCollectionCreator: RxCollectionCreator = {
  schema: issuePrioritySchema,
}
